import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-38445632"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row mb-5" }
const _hoisted_2 = { class: "col-md-9 text-start" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chevron-left text-primary" }, null, -1))
const _hoisted_4 = {
  key: 0,
  class: "col-md-3"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bi bi-linkedin" }, null, -1))
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "row g-5" }
const _hoisted_8 = { class: "col-xl-3" }
const _hoisted_9 = { class: "card card-xl-stretch mb-xl-8" }
const _hoisted_10 = { class: "card-body d-flex flex-column p-0" }
const _hoisted_11 = {
  class: "d-flex flex-center justify-content-center",
  style: {"height":"150px"}
}
const _hoisted_12 = { class: "d-flex flex-center justify-content-center my-3" }
const _hoisted_13 = { class: "d-flex flex-center justify-content-center" }
const _hoisted_14 = { class: "fs-7 text-center text-gray-700 px-2" }
const _hoisted_15 = { class: "col-xl-9" }
const _hoisted_16 = { class: "card card-xl-stretch text-gray-700" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, "FeedBack")
], -1))
const _hoisted_18 = {
  class: "p-3 card-scroll",
  style: {"height":"140px"}
}
const _hoisted_19 = { class: "fs-6" }
const _hoisted_20 = { class: "fs-6" }
const _hoisted_21 = {
  class: "fs-6",
  style: {"white-space":"pre-line"}
}
const _hoisted_22 = { class: "card shadow-sm" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title text-gray-800" }, "Feedback Hacking Club"),
  /*#__PURE__*/_createElementVNode("div", { class: "card-toolbar" })
], -1))
const _hoisted_24 = { class: "card-body" }
const _hoisted_25 = { class: "fs-4 text-gray-700" }
const _hoisted_26 = { class: "row mt-5 mx-1" }
const _hoisted_27 = { class: "card" }
const _hoisted_28 = { class: "card-body" }
const _hoisted_29 = { class: "d-flex flex-column" }
const _hoisted_30 = { class: "justify-content-center d-flex align-items-center" }
const _hoisted_31 = { class: "" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-file-earmark-arrow-down fs-2 text-white mt-1" }, null, -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-repeat fs-2 text-white mt-1" }, null, -1))
const _hoisted_34 = {
  key: 2,
  class: "upload-btn-disabled bg-gray-300 text-gray-500"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-file-earmark-arrow-down fs-2 text-gray-500 mt-1" }, null, -1))
const _hoisted_36 = {
  key: 1,
  class: "d-flex flex-column py-6"
}
const _hoisted_37 = { class: "container text-center mt-5" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "spinner-border text-primary",
  role: "status"
}, null, -1))
const _hoisted_39 = { class: "text-muted fs-3 fw-bold mt-3 mb-6" }

import {computed, onMounted, ref, onBeforeMount} from "vue";
import {useRouter} from "vue-router";
import {useStore} from "vuex";
import CardMachine from "@/components/certification/CardMachine.vue";
import {Actions, Mutations} from "@/store/enums/StoreEnums";
import ApiService from "@/core/services/ApiService";
import {CertificationDataType} from "@/types/CertificationType";
import {useI18n} from "vue-i18n";
import moment from "moment";
import {useCertificationSteps} from "@/core/composables/useCertificationSteps";
import {formatBrasilia} from "@/core/helpers/dates";


export default /*#__PURE__*/_defineComponent({
  props: {
    id: null
  },
  setup(__props: any) {

const props = __props as {
  id: string;
}



const { t } = useI18n();
const store = useStore();
const router = useRouter();
const currentLanguage = computed(() => store.getters.getCurrentLanguage || localStorage.getItem('currentLanguage'));
const userCertification = ref<CertificationDataType | undefined>();
const certificationOK = ref(false);

const {
  loadCertificationData,
  statusData,
  getStepRoute,
  currentStep,
  configData,
} = useCertificationSteps(props.id, 'certification_feedback');

const approvalMessage = computed(() => configData.value?.approval_message?.trim() || null);
const terms = ref(false);
const isChecked = ref(false);
const loading = ref(false);
const approvedCertification = ref(false)
const url = ref<string | undefined>('');

const deadlineSendReport = computed(() => formatBrasilia(userCertification.value?.deadline_send_report, 'DD/MM/YY'));
const dateTimeout = computed(() => formatBrasilia(userCertification.value?.timeout, 'DD/MM/YY'));

const feedbackCertification = async () => {
  try {
    // Carrega configuração e status da certificação
    await loadCertificationData();
    
    // Se statusData foi carregado, usa ele; senão, busca novamente
    if (statusData.value) {
      userCertification.value = statusData.value;
    } else {
      const {data, status} = await ApiService.get(`/certification/status/${props.id}`);
      if (status === 200) {
        userCertification.value = data.data;
      }
    }

    // Verifica se há um step atual válido
    if (currentStep.value > 0) {
      const expectedRoute = getStepRoute(currentStep.value);
      
      // Se não estamos na rota correta para o step atual, redireciona
      if (expectedRoute && expectedRoute !== 'certifications-feedback') {
        console.log(`Redirecionando para ${expectedRoute}`);
        await router.push({ name: expectedRoute, params: {id: props.id}});
        return;
      }
    } else {
      // Se não há step válido, redireciona para listagem
      console.log("Redirecionando para listagem");
      await router.push({name: 'certifications'});
      return;
    }

    // Verifica se a certificação foi aprovada
    if(
        (userCertification.value?.approved === 1 && userCertification.value?.approved !== null) &&
        (userCertification.value?.grade >= 7 && userCertification.value?.grade !== null)
    ){
        certificationOK.value = true;
    }
  } catch (e) {
    console.error("Erro ao carregar certificação:", e);
    // Em caso de erro, redireciona para listagem
    if(e.response?.data?.message === "certificado ainda não iniciado" || !statusData.value){
      console.log("Redirecionando para listagem");
      await router.push({name: 'certifications'});
    }
  }finally {
    loading.value = false;
  }
}

onMounted(async () => {
  loading.value = true;
  try{
    await feedbackCertification();
  }catch (e) {
    console.log(e)
  }finally {
    loading.value = false;
  }
})
const checkedTerms = () => {
  isChecked.value = !isChecked.value;
  terms.value = isChecked.value;
}

const gradeCertification = computed(() => {
  if(userCertification.value?.grade === null){
    return {
      grade: '-',
      class1: 'border-gray-500',
      class2: 'bg-gray-200 text-gray-500',
      class3: 'text-gray-500',
      title: t(`${currentLanguage.value}.certification.feedback.grade_null_title`),
      text: t(`${currentLanguage.value}.certification.feedback.grade_null_text`)
    }
  }else if(userCertification.value?.grade < 7){
    return {
      grade: userCertification.value?.grade,
      class1: 'border-danger',
      class2: 'bg-light-danger text-danger',
      class3: 'text-danger',
      title: t(`${currentLanguage.value}.certification.feedback.grade_smaller_7_title`),
      text: t(`${currentLanguage.value}.certification.feedback.grade_smaller_7_text`)
    }
  }else{
      return {
        grade: userCertification.value?.grade,
        class1: 'border-success',
        class2: 'bg-light-success text-success',
        class3: 'text-success',
        title: t(`${currentLanguage.value}.certification.feedback.grade_bigger_7_title`),
        text: t(`${currentLanguage.value}.certification.feedback.grade_bigger_7_text`)
      }
  }
})

const commentCertification = computed(() => {
  if(userCertification.value?.comment === null){
    return {
      comment: t(`${currentLanguage.value}.certification.feedback.comment_null`),
    }
  }else if(userCertification.value?.comment === "user disapproved"){
    return {
      //deadlineSendReport
      comment: t(`${currentLanguage.value}.certification.feedback.desc_comment_1`) + `${dateTimeout.value}` + t(`${currentLanguage.value}.certification.feedback.desc_comment_2`) + ` (${deadlineSendReport.value}) ` + t(`${currentLanguage.value}.certification.feedback.desc_comment_3`),
    }
  }else{
    return {
      comment: userCertification.value?.comment,
    }
  }
})
//(userCertification?.approved === 1 && userCertification?.approved !== null) && (userCertification?.grade >= 7 && userCertification?.grade !== null)
// const approvedCertification = computed(() => {
//     if((userCertification.value?.approved === 1 && userCertification.value?.approved !== null) && (userCertification.value?.grade >= 7 && userCertification.value?.grade !== null)){
//       return true;
//     }else{
//       return false;
//     }
// });

const handleDownloadCertification = async () => {
  try {
    const certificate_data = await ApiService.get(`/certification/download/${props.id}`);
    if(certificate_data.status !== 200) return console.error("Erro ao redirecionar:", certificate_data);
    const url = certificate_data.data.url;
    window.open(url, '_blank');
  } catch (e) {
    console.error("Erro ao redirecionar:", e);
  }
}

const canRetry = computed(() => userCertification.value?.can_retry === true);

const handleRetryCertification = () => {
  router.push({ name: 'certifications-detail', params: { id: props.id } });
}

const shareOnLinkedin = () => {
    store.commit(Mutations.SET_SHOW_CERTIFICATION_ACHIEVEMENTS, true);
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_link, {
          to: { name: 'certifications' },
          class: "text-primary"
        }, {
          default: _withCtx(() => [
            _hoisted_3,
            _createTextVNode(" " + _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.back`)), 1)
          ]),
          _: 1
        })
      ]),
      (userCertification.value?.approved === 1 && userCertification.value?.approved !== null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("button", {
              onClick: shareOnLinkedin,
              type: "button",
              class: "btn btn-primary",
              style: {"font-size":"13px"}
            }, [
              _hoisted_5,
              _createTextVNode(" " + _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.share_on_linkedin`)), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (!loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["symbol symbol-100px border", _unref(gradeCertification)?.class1])
                    }, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["symbol-label fw-bold", _unref(gradeCertification)?.class2]),
                        style: {"font-size":"3.5rem"}
                      }, _toDisplayString(_unref(gradeCertification)?.grade), 3)
                    ], 2)
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("h3", {
                      class: _normalizeClass(["mb-0 text-center fs-3 fw-bolder", _unref(gradeCertification)?.class3]),
                      style: {"margin-top":"-15px"}
                    }, _toDisplayString(_unref(gradeCertification)?.title), 3)
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(gradeCertification)?.text), 1)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("p", _hoisted_19, [
                    _createElementVNode("b", null, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.feedback.approved`)) + ":", 1),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.feedback.approved_desc`)), 1)
                  ]),
                  _createElementVNode("p", _hoisted_20, [
                    _createElementVNode("b", null, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.feedback.no_approved`)) + ":", 1),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.feedback.no_approved_desc`)), 1)
                  ]),
                  _createElementVNode("p", _hoisted_21, _toDisplayString(_unref(approvalMessage) ?? _ctx.$t(`${_unref(currentLanguage)}.certification.feedback.description`)), 1)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _hoisted_23,
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("p", _hoisted_25, _toDisplayString(_unref(commentCertification)?.comment), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, [
                      (certificationOK.value)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            onClick: handleDownloadCertification,
                            class: "upload-btn"
                          }, [
                            _hoisted_32,
                            _createTextVNode(" " + _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.feedback.your_certification`)), 1)
                          ]))
                        : (_unref(canRetry))
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              onClick: handleRetryCertification,
                              class: "upload-btn"
                            }, [
                              _hoisted_33,
                              _createTextVNode(" " + _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.messages.try_again`)), 1)
                            ]))
                          : (_openBlock(), _createElementBlock("button", _hoisted_34, [
                              _hoisted_35,
                              _createTextVNode(" " + _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.feedback.your_certification`)), 1)
                            ]))
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_36, [
          _createElementVNode("div", _hoisted_37, [
            _hoisted_38,
            _createElementVNode("span", _hoisted_39, "    " + _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.send_report.analyzing`)) + " " + _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.send_report.report`)) + "... ", 1)
          ])
        ]))
  ], 64))
}
}

})